export default {"src":"/_next/static/media/signup.67cd155e.svg","height":515,"width":529};